/**
 * @file Input component for file input
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { Renderer, ElementRef } from '@angular/core';
import { UploadInput } from '../../../base/inputs/input-upload/input-upload.component';
import { AlertsService } from '../../../core/alerts.service';
import { FilesService } from '../../files.service';
/**
 * Class for the file input component
 */
var InputFileComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InputFileComponent, _super);
    /**
     * Constructs a InputFileComponent.
     * @param renderer Render used to perform action in DOM
     * @param alertsService Service for giving user feedback
     */
    function InputFileComponent(renderer, alertsService, filesService) {
        var _this = _super.call(this, alertsService, filesService) || this;
        _this.renderer = renderer;
        _this.alertsService = alertsService;
        return _this;
    }
    /**
     * Open the file dialog
     */
    InputFileComponent.prototype.openFileDialog = function () {
        this.renderer.invokeElementMethod(this.inputFile.nativeElement, 'click', []);
    };
    return InputFileComponent;
}(UploadInput));
export { InputFileComponent };
